import * as React from "react";

import { FullPageErrorModal } from "@v1/components/editor/page/FullPageErrorModal";
import EmptyLayout from "@v1/layouts/EmptyLayout";
import { useSearchParams } from "react-router-dom";

const ShopifyInstalledOnExistingWorkspaceLayout = () => {
  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get("workspaceId");
  const workspaceName = searchParams.get("workspaceName");

  return (
    <EmptyLayout>
      <FullPageErrorModal
        isClosable={false}
        details={{
          header: "Shopify Store Already Installed",
          subheader: `This Shopify Integration is already connected to the workspace ${workspaceName ? `"${workspaceName}"` : ""}.`,
          message: `In order to connect this Shopify Integration to a different workspace, you will first need to disconnect it from ${workspaceName ? `"${workspaceName}"` : "the existing workspace"}.`,
          callToAction: {
            type: "navigate",
            location: {
              type: "workspace",
              workspaceId: workspaceId ?? "",
              workspaceName: workspaceName ?? "",
            },
          },
        }}
      />
    </EmptyLayout>
  );
};

export default ShopifyInstalledOnExistingWorkspaceLayout;
